export default __webpack_public_path__ + "media/images/front/about/snscheck_sp-cc0119704a680f40491db1d9160d6e3f.png";